import React, { useState, useEffect } from "react";
import "./FeedStyle.css";
import { observer } from "mobx-react";
import { useLocation, useSearchParams } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { getFeedListing } from "../../feedrequests";
import ReactGA from 'react-ga4';

function FeedPage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  const [initialized, setInitialized] = useState(false);
  const [url, setUrl] = useState("");
  const [listings, setListings] = useState([]);
  const [data, setData] = useState({});
  const [error, setError] = useState(null);

  const getListings = async url => {
    setError(null);
    try {
      const response = await getFeedListing(url);
      setListings(response.data.items);
      setData(response.data.feed);
    } catch (ex) {
      setError("Failed to load the RSS feed. Please verify the URL and try again.");
    }
  };
  const openLink = url => {
    window.location.href = url;
  };
  useEffect(() => {
    if (!initialized) {
      // useSearchParams replaces the need for the 'querystring' module
      const feedUrl = searchParams.get("url"); 
      if (feedUrl) {
        setUrl(feedUrl);
        getListings(feedUrl);
      }
      setInitialized(true);
    }
  }, [initialized, searchParams]);
  return (
    <div className="feed-page">
      {data.title && (
        <h1 className="center title">
          <img src={data.image} alt="RSS Feed Logo"/> {data.title}
        </h1>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      {listings.map((l, i) => {
        return (
          <Card key={i}>
            <Card.Title className="card-title">{l.title}</Card.Title>
            <Card.Body>
              <p>{l.description}</p>
              <p>{l.content}</p>
              <Button variant="primary" onClick={() => openLink(l.link)}>
                Open
              </Button>{" "}
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
}
export default observer(FeedPage);